import { render, staticRenderFns } from "./GigOfferChatMessage.htm?vue&type=template&id=92c04dc0&scoped=true&"
import script from "./GigOfferChatMessage.ts?vue&type=script&lang=js&"
export * from "./GigOfferChatMessage.ts?vue&type=script&lang=js&"
import style0 from "./GigOfferChatMessage.scss?vue&type=style&index=0&id=92c04dc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c04dc0",
  null
  
)

export default component.exports